import { render, staticRenderFns } from "./fooddelivery.vue?vue&type=template&id=c3b19728&scoped=true&"
import script from "./fooddelivery.vue?vue&type=script&lang=js&"
export * from "./fooddelivery.vue?vue&type=script&lang=js&"
import style0 from "./fooddelivery.vue?vue&type=style&index=0&id=c3b19728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b19728",
  null
  
)

export default component.exports